import { useState } from "react";
import getUrl from "../../tools/get-domain";
import { humanizeNumber } from "../../tools/market/functions";

export default function Calculator({ inputFields, strategyName }) {
    const [isLoading, setIsLoading] = useState(false);

    const inputChangeHandler = (e) => {
        const numericValue = e.target.value.replace(/[^0-9.]/g, "");
        const formattedValue = Number(numericValue).toLocaleString();
        e.target.value = formattedValue === "0" ? "" : formattedValue;
    };

    const handleSubmitForm = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        const form = new FormData(event.target);
        const parameters = Object.fromEntries(
            Array.from(form.entries()).map(([key, value]) => [
                key,
                isNaN(value) || value === ""
                    ? Number(value.replaceAll(",", ""))
                    : Number(value.replaceAll(",", "")), // Convert to number if possible
            ])
        );

        const url = new URL(
            `${getUrl().REACT_APP_STRATEGY_CALCULATOR}${strategyName}`
        );
        url.searchParams.append("parameters", JSON.stringify(parameters));

        const response = await fetch(url, {
            method: "GET",
        });

        const data = await response.json();

        if ("errors" in data) {
            document.querySelector("#error").innerHTML = data["errors"][0];
        } else {
            // fill output fields with result
            Object.entries(data).forEach(([key, value]) => {
                const input = document.querySelector(`input[id="${key}"]`);

                if (input) {
                    input.value = humanizeNumber(value);
                }
            });
            document.querySelector("#error").innerHTML = "";
        }

        setIsLoading(false);
    };

    return (
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2">
            {/* Input */}
            <form onSubmit={handleSubmitForm}>
                <div className="md:tw-border-l md:tw-border-gray-200 md:tw-pl-3 tw-h-full">
                    <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                        {inputFields.map((field) =>
                            !field.output ? (
                                <div
                                    className="tw-flex tw-flex-col"
                                    key={field.id}
                                >
                                    <label
                                        htmlFor={field.title}
                                        className="tw-block tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-1"
                                        style={{
                                            textShadow:
                                                "1px 1px 2px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        {field.verbose}
                                    </label>
                                    <input
                                        onChange={inputChangeHandler}
                                        id={field.title}
                                        dir="ltr"
                                        type="text"
                                        name={field.title}
                                        placeholder={`${field.verbose} را وارد کن`}
                                        className="tw-px-4 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-bg-gray-100 tw-h-12 tw-text-gray-900 tw-text-sm tw-font-medium focus:tw-outline-none focus:tw-border-blue-400 focus:tw-shadow-[0_4px_15px_rgba(0,0,0,0.2)]"
                                        style={{
                                            background:
                                                "linear-gradient(145deg, #ffffff, #e6e6e6)",
                                            boxShadow:
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff",
                                            transition: "all 0.3s ease-in-out",
                                        }}
                                        onFocus={(e) =>
                                            (e.target.style.boxShadow =
                                                "6px 6px 10px #d1d2d3, -6px -6px 10px #ffffff")
                                        }
                                        onBlur={(e) =>
                                            (e.target.style.boxShadow =
                                                "4px 4px 6px #d1d2d3, -4px -4px 6px #ffffff")
                                        }
                                    />
                                </div>
                            ) : (
                                <input
                                    key={field.id}
                                    type="hidden"
                                    name={field.title}
                                />
                            )
                        )}
                    </div>
                    <div className="tw-flex tw-items-center tw-justify-between tw-mt-6 max-md:tw-mb-6">
                        <div
                            className="tw-text-red-600 tw-text-lg"
                            id="error"
                        ></div>
                        <button
                            disabled={isLoading}
                            type="submit"
                            className="tw-px-4 tw-bg-gradient-to-r tw-from-cyan-500 tw-to-blue-500 tw-text-white tw-h-12 tw-rounded-lg"
                        >
                            {isLoading ? "منتظر بمانید" : "محاسبه"}
                        </button>
                    </div>
                </div>
            </form>

            {/* Output */}
            <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-4 tw-h-fit">
                {inputFields.map(
                    (field) =>
                        field.output && (
                            <div className="tw-flex tw-flex-col" key={field.id}>
                                <label
                                    htmlFor=""
                                    className="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1"
                                >
                                    {field.verbose}
                                </label>
                                <input
                                    readOnly
                                    disabled
                                    dir="ltr"
                                    id={field.title}
                                    type="text"
                                    name={field.title}
                                    className="tw-px-2 tw-w-full tw-rounded-xl tw-border tw-border-gray-300 tw-bg-gray-100 tw-h-12 tw-pr-3 tw-text-gray-900"
                                    style={{
                                        borderRadius: "8px",
                                        background: "#f9fafb",
                                        boxShadow:
                                            "inset 5px 5px 1px #d1d2d3, inset -5px -5px 1px #ffffff",
                                    }}
                                />
                            </div>
                        )
                )}
            </div>
        </div>
    );
}
